(function(){
  function clamp(value,min,max){return Math.min(Math.max(value,min),max);}

  function initProduct(root){
    if(!root || root.dataset.plpReady==='true') return;
    root.dataset.plpReady='true';

    var main=root.querySelector('[data-plp-main]');
    var heroItem=root.querySelector('[data-plp-hero-item]');
    var mediaItems=Array.prototype.slice.call(root.querySelectorAll('[data-plp-media-item]'));
    var thumbs=Array.prototype.slice.call(root.querySelectorAll('[data-plp-thumb]'));

    function stopMedia(item){
      if(!item) return;
      item.querySelectorAll('video').forEach(function(video){try{video.pause();}catch(error){}});
      item.querySelectorAll('model-viewer').forEach(function(model){try{if(typeof model.pause==='function') model.pause();}catch(error){}});
      item.querySelectorAll('iframe').forEach(function(frame){
        try{
          if(frame.src){
            var source=frame.src;
            frame.src='about:blank';
            window.setTimeout(function(){frame.src=source;},0);
          }
        }catch(error){}
      });
    }

    function activateMedia(targetId,button){
      var target=targetId?mediaItems.find(function(item){return item.id===targetId;}):null;
      if(!target) return;
      mediaItems.forEach(function(item){
        var active=item===target;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-hidden',active?'false':'true');
        if(!active) stopMedia(item);
      });
      thumbs.forEach(function(item){item.classList.toggle('is-active',item===button || item.dataset.target===targetId);});
    }

    thumbs.forEach(function(button){
      button.addEventListener('click',function(){activateMedia(button.dataset.target,button);});
    });

    var variant=root.querySelector('[data-plp-variant]');
    if(variant){
      variant.addEventListener('change',function(){
        var option=variant.options[variant.selectedIndex];
        var price=root.querySelector('[data-plp-price]');
        var compare=root.querySelector('[data-plp-compare]');
        var add=root.querySelector('[data-plp-add]');
        var addLabel=root.querySelector('[data-plp-add-label]');
        var available=option.dataset.available==='true';
        if(price && option.dataset.price) price.textContent=option.dataset.price;
        if(compare){compare.textContent=option.dataset.compare||'';compare.classList.toggle('is-hidden',!option.dataset.compare);}
        if(add) add.disabled=!available;
        if(addLabel) addLabel.textContent=available?'Add to Cart':'Sold Out';
        if(main && option.dataset.image){
          main.classList.add('is-switching');
          window.setTimeout(function(){
            main.src=option.dataset.image;
            main.removeAttribute('srcset');
            main.classList.remove('plp-gallery__main--natural');
            main.classList.add('plp-gallery__main--blend');
            main.classList.remove('is-switching');
            if(heroItem){
              var heroThumb=thumbs.find(function(item){return item.dataset.target===heroItem.id;});
              activateMedia(heroItem.id,heroThumb||null);
            }
          },140);
        }
        try{var url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url.toString());}catch(error){}
      });
    }

    var tasting=root.querySelector('[data-plp-tasting-story]');
    if(tasting){
      var notes=Array.prototype.slice.call(tasting.querySelectorAll('[data-plp-tasting-note]'));
      var bottle=tasting.querySelector('[data-plp-tasting-bottle]');
      var word=tasting.querySelector('[data-plp-tasting-word]');
      var progress=tasting.querySelector('[data-plp-tasting-progress]');
      var scheduled=false;
      var reduced=window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function updateTasting(){
        scheduled=false;
        if(!notes.length) return;
        var anchor=window.innerHeight*.52;
        var index=0;
        var closest=Infinity;
        notes.forEach(function(note,noteIndex){
          var noteRect=note.getBoundingClientRect();
          var noteCenter=noteRect.top+(noteRect.height/2);
          var distance=Math.abs(noteCenter-anchor);
          if(distance<closest){closest=distance;index=noteIndex;}
        });
        notes.forEach(function(note,noteIndex){note.classList.toggle('is-active',noteIndex===index);});
        if(word && notes[index]) word.textContent=notes[index].dataset.word||'';
        if(progress) progress.style.width=((index+1)/notes.length*100)+'%';
        if(bottle && !reduced){
          var position=notes.length>1?index/(notes.length-1):0;
          var rotation=position*8-4;
          var lift=index===1?-10:0;
          var scale=1+position*.04;
          bottle.style.transform='translate(-50%,-50%) rotate('+rotation+'deg) translateY('+lift+'px) scale('+scale+')';
          bottle.style.filter='drop-shadow(0 '+(48+position*12)+'px '+(32+position*6)+'px rgba(0,0,0,.6))';
        }
      }
      function requestTasting(){if(!scheduled){scheduled=true;window.requestAnimationFrame(updateTasting);}}
      window.addEventListener('scroll',requestTasting,{passive:true});
      window.addEventListener('resize',requestTasting,{passive:true});
      updateTasting();
    }

    var rail=root.querySelector('[data-plp-related-rail]');
    if(rail){
      var previous=root.querySelector('[data-plp-related-prev]');
      var next=root.querySelector('[data-plp-related-next]');
      function step(){var card=rail.querySelector('.plp-continue-card');return card?card.getBoundingClientRect().width+18:340;}
      if(previous) previous.addEventListener('click',function(){rail.scrollBy({left:-step(),behavior:'smooth'});});
      if(next) next.addEventListener('click',function(){rail.scrollBy({left:step(),behavior:'smooth'});});

    }

    var revealItems=root.querySelectorAll('.plp-reveal');
    if('IntersectionObserver' in window){
      var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.08,rootMargin:'0px 0px -40px'});
      revealItems.forEach(function(item){observer.observe(item);});
    }else{revealItems.forEach(function(item){item.classList.add('is-visible');});}
  }

  function initAll(scope){(scope||document).querySelectorAll('[data-plp-product]').forEach(initProduct);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initAll(document);}); else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target);});
})();
